import React, { useState } from 'react';

const countries = [
  { code: '+91', name: 'India', flag: '🇮🇳' },
  { code: '+1', name: 'United States', flag: '🇺🇸' },
  { code: '+44', name: 'United Kingdom', flag: '🇬🇧' },
  { code: '+61', name: 'Australia', flag: '🇦🇺' },
  { code: '+1', name: 'Canada', flag: '🇨🇦' },
];

interface PhoneInputWithCountryProps {
  value: string;
  onChange: (value: string) => void;
}

const PhoneInputWithCountry: React.FC<PhoneInputWithCountryProps> = ({ value, onChange }) => {
  // Default to India
  const [country, setCountry] = useState(countries[0]);
  const [phone, setPhone] = useState(value.replace(/^\+\d+\s*/, ''));

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = countries.find(c => c.code === e.target.value) || countries[0];
    setCountry(selected);
    onChange(`${selected.code} ${phone}`);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPhone = e.target.value.replace(/[^0-9]/g, '');
    setPhone(newPhone);
    onChange(`${country.code} ${newPhone}`);
  };

  return (
    <div className="flex rounded-lg border border-white/30 dark:border-gray-600/50 bg-white/50 dark:bg-gray-700/50 backdrop-blur-sm focus-within:ring-2 focus-within:ring-purple-500 dark:focus-within:ring-purple-400 transition-all duration-200">
      <select
        className="bg-transparent pl-2 pr-1 py-2 text-gray-900 dark:text-white focus:outline-none"
        value={country.code}
        onChange={handleCountryChange}
      >
        {countries.map(c => (
          <option key={c.code + c.name} value={c.code}>
            {c.flag} {c.name} ({c.code})
          </option>
        ))}
      </select>
      <input
        type="tel"
        className="flex-1 px-3 py-2 bg-transparent text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none"
        placeholder="Phone number"
        value={phone}
        onChange={handlePhoneChange}
        maxLength={15}
      />
    </div>
  );
};

export default PhoneInputWithCountry; 